import { IVerificationCode } from "@features/PortIn/components/ValidatePhoneNumber/PhoneNumber/interface/IVerificationCode";

interface IPhoneNumberPayload {
    msisdn: string;
    brand: string;
}

export const getStateToPayload = (phoneNumber: string, brand: string): IPhoneNumberPayload => ({
    msisdn: phoneNumber,
    brand,
});

export interface IVerificationCodeApiResponse {
    otpUuid: string;
}

export const getResponseToState = (response: IVerificationCodeApiResponse): IVerificationCode => ({
    otpUuid: response.otpUuid,
});
